import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  Input,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageModalComponent } from 'src/app/shared/components/images-modal/image-modal.component';

@Directive({
  selector: '[imageViewer]',
  standalone: true,
})
export class ImageViewerDirective {
  @Input('imageViewer') isActive: boolean = true; // شرط برای فعال بودن دایرکتیو

  dialog = inject(MatDialog);
  elementRef = inject(ElementRef);
  src: string;

  @HostListener('click') onClick() {
    if (this.isActive) this.openImageModal();
  }

  ngOnInit(): void {
    if (this.isActive) {
      const src = (
        this.elementRef.nativeElement as HTMLImageElement
      ).getAttribute('src');
      if (!src)
        (this.elementRef.nativeElement as HTMLImageElement).src =
          'assets/images/svg/icons/camera.svg';
    }
  }

  openImageModal() {
    const src = (this.elementRef.nativeElement as HTMLImageElement).src;
    if (!src || src.includes('assets/images/svg/icons/camera.svg')) return;
    this.dialog.open(ImageModalComponent, {
      height: '100%',
      width: '100%',
      maxWidth: '100%',
      panelClass: 'show-image-modal',
      data: {
        image: src,
      },
      disableClose: false,
    });
  }
}
